export default __webpack_public_path__ + "static/media/server-blue.13ba659c.svg";